import { APP_NAME } from 'constants/app';
import { COLOR_PRIMARY } from 'constants/color';
import AppLoading from 'expo-app-loading';
import { StatusBar } from 'expo-status-bar';
import useFonts from 'hooks/useFonts';
import store from 'modules/store';
import React from 'react';
import { DefaultTheme, Provider as PaperProvider } from 'react-native-paper';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import EditScreen from 'screens/EditScreen';
import ResultScreen from 'screens/ResultScreen';
import { RootStackParamList } from 'types/RootStackParamList';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

const Stack = createStackNavigator<RootStackParamList>();

const App: React.VFC = () => {
	const { fontsLoaded } = useFonts();

	if (!fontsLoaded) {
		return <AppLoading />;
	}
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistStore(store)}>
				<StatusBar hidden />
				<PaperProvider
					theme={{
						...DefaultTheme,
						colors: {
							...DefaultTheme.colors,
							primary: COLOR_PRIMARY,
						},
					}}>
					<NavigationContainer>
						<Stack.Navigator initialRouteName="Edit">
							<Stack.Screen
								name="Edit"
								component={EditScreen}
								options={{
									header: () => null,
									title: `${APP_NAME}`,
								}}
							/>
							<Stack.Screen
								name="Result"
								component={ResultScreen}
								options={{
									header: () => null,
									title: `${APP_NAME}`,
								}}
							/>
						</Stack.Navigator>
					</NavigationContainer>
				</PaperProvider>
			</PersistGate>
		</Provider>
	);
};

export default App;
